// extracted by mini-css-extract-plugin
export var boxItems = "_9m-1";
export var boxItemsLg = "_9m-2";
export var button = "_9m-7";
export var buttonHoverless = "_9m-9";
export var buttonLg = "_9m-8";
export var filterGroupBox = "_9m-0";
export var icon = "_9m-3";
export var iconSecondary = "_9m-6";
export var iconWrapper = "_9m-4";
export var iconWrapperLg = "_9m-5";
export var truncatedLabel = "_9m-a";